/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ====================================
   WISHLIST / MERKLISTE - Urban Parts
   ==================================== */

(function() {
  'use strict';

  const STORAGE_KEY = 'urbanparts_wishlist';

  // Wishlist aus localStorage laden
  function getWishlist() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  // Wishlist in localStorage speichern
  function saveWishlist(wishlist) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
    } catch (e) {
      console.error('Wishlist save failed:', e);
    }
  }

  // Prüfen ob Produkt auf Wishlist
  function isInWishlist(productId) {
    const wishlist = getWishlist();
    return wishlist.some(item => item.id === productId);
  }

  // Produkt zur Wishlist hinzufügen
  function addToWishlist(productId, productHandle, productTitle, productImage, productUrl) {
    const wishlist = getWishlist();
    if (!isInWishlist(productId)) {
      wishlist.push({
        id: productId,
        handle: productHandle,
        title: productTitle,
        image: productImage,
        url: productUrl,
        addedAt: new Date().toISOString()
      });
      saveWishlist(wishlist);
      updateWishlistUI();
      showWishlistNotice('added');
    }
  }

  // Produkt von Wishlist entfernen
  function removeFromWishlist(productId) {
    let wishlist = getWishlist();
    wishlist = wishlist.filter(item => item.id !== productId);
    saveWishlist(wishlist);
    updateWishlistUI();
    showWishlistNotice('removed');
  }

  // Wishlist toggle
  function toggleWishlist(productId, productHandle, productTitle, productImage, productUrl) {
    if (isInWishlist(productId)) {
      removeFromWishlist(productId);
    } else {
      addToWishlist(productId, productHandle, productTitle, productImage, productUrl);
    }
  }

  // UI aktualisieren (alle Buttons + Counter)
  function updateWishlistUI() {
    const wishlist = getWishlist();
    const count = wishlist.length;

    // Counter im Header aktualisieren
    const counters = document.querySelectorAll('.wishlist-count');
    counters.forEach(counter => {
      counter.textContent = count;
      counter.style.display = count > 0 ? 'flex' : 'none';
    });

    // Alle Wishlist-Buttons aktualisieren
    const buttons = document.querySelectorAll('[data-wishlist-btn]');
    buttons.forEach(btn => {
      const productId = parseInt(btn.dataset.productId, 10);
      const isActive = isInWishlist(productId);
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive);

      // Icon bleibt gleich (Bookmark), nur fill ändert sich via CSS
    });

    // Wishlist-Seite aktualisieren falls vorhanden
    renderWishlistPage();
  }

  // Benachrichtigung anzeigen
  function showWishlistNotice(action) {
    // Entferne alte Notices
    const oldNotice = document.querySelector('.wishlist-notice');
    if (oldNotice) oldNotice.remove();

    const notice = document.createElement('div');
    notice.className = 'wishlist-notice';
    notice.innerHTML = action === 'added'
      ? '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg> Zur Merkliste hinzugefügt'
      : '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg> Von Merkliste entfernt';

    document.body.appendChild(notice);

    // Animation
    requestAnimationFrame(() => {
      notice.classList.add('is-visible');
    });

    setTimeout(() => {
      notice.classList.remove('is-visible');
      setTimeout(() => notice.remove(), 300);
    }, 2500);
  }

  // Wishlist-Seite rendern
  function renderWishlistPage() {
    const container = document.getElementById('wishlist-items');
    if (!container) return;

    const wishlist = getWishlist();
    const emptyMessage = document.getElementById('wishlist-empty');
    const wishlistContent = document.getElementById('wishlist-content');

    if (wishlist.length === 0) {
      if (emptyMessage) emptyMessage.style.display = 'block';
      if (wishlistContent) wishlistContent.style.display = 'none';
      return;
    }

    if (emptyMessage) emptyMessage.style.display = 'none';
    if (wishlistContent) wishlistContent.style.display = 'block';

    container.innerHTML = wishlist.map(item => `
      <div class="wishlist-item" data-product-id="${item.id}">
        <a href="${item.url}" class="wishlist-item__image">
          <img src="${item.image || '/cdn/shop/products/placeholder.png?width=200'}" alt="${item.title}" loading="lazy">
        </a>
        <div class="wishlist-item__info">
          <a href="${item.url}" class="wishlist-item__title">${item.title}</a>
          <a href="${item.url}" class="button button--primary button--small">Zum Produkt</a>
        </div>
        <button type="button" class="wishlist-item__remove" data-remove-wishlist="${item.id}" aria-label="Entfernen">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>
    `).join('');

    // Event Listener für Remove-Buttons
    container.querySelectorAll('[data-remove-wishlist]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const productId = parseInt(btn.dataset.removeWishlist, 10);
        removeFromWishlist(productId);
      });
    });
  }

  // Event Delegation für Wishlist-Buttons
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = parseInt(btn.dataset.productId, 10);
    const productHandle = btn.dataset.productHandle || '';
    const productTitle = btn.dataset.productTitle || '';
    const productImage = btn.dataset.productImage || '';
    const productUrl = btn.dataset.productUrl || '';

    toggleWishlist(productId, productHandle, productTitle, productImage, productUrl);
  });

  // Initial UI Update
  document.addEventListener('DOMContentLoaded', function() {
    updateWishlistUI();
  });

  // Global verfügbar machen
  window.UrbanPartsWishlist = {
    get: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist,
    isIn: isInWishlist,
    update: updateWishlistUI
  };

})();

/* ====================================
   RESTOCK SPLIT-NOTIFICATION
   Zeigt beim Add-to-Cart einen Hinweis
   wenn qty > Lagerbestand
   ==================================== */

(function() {
  'use strict';

  document.addEventListener('product:added', function(event) {
    var quantity = event.detail.quantity;
    if (!quantity || quantity <= 0) return;

    // Restock-Daten aus dem versteckten JSON-Block suchen
    var restockScripts = document.querySelectorAll('script[id^="restock-data-"]');
    if (!restockScripts.length) return;

    // Nehme das erste (auf der Produktseite gibt es normalerweise nur eins)
    var restockData = null;
    for (var i = 0; i < restockScripts.length; i++) {
      try {
        restockData = JSON.parse(restockScripts[i].textContent);
        break;
      } catch(e) { continue; }
    }

    if (!restockData || !restockData.hasRestockData) return;

    var inventory = restockData.inventory;
    if (inventory <= 0 || quantity <= inventory) return;

    // Split-Situation: qty > Bestand
    var ready = inventory;
    var remaining = quantity - inventory;
    var message = '';

    if (restockData.restockDate && restockData.restockDate !== 'null') {
      message = ready + ' Stück kurzfristig versandbereit. ' + remaining + ' Stück voraussichtlich wieder verfügbar am ' + restockData.restockDate + '.';
    } else if (restockData.restockWeeks && restockData.restockWeeks !== null) {
      message = ready + ' Stück kurzfristig versandbereit. ' + remaining + ' Stück voraussichtlich verfügbar in ' + restockData.restockWeeks + ' Wochen.';
    }

    if (!message) return;

    // Bestehende Notices entfernen
    var oldNotice = document.querySelector('.restock-add-notice');
    if (oldNotice) oldNotice.remove();

    // Notice erstellen
    var notice = document.createElement('div');
    notice.className = 'restock-add-notice';
    notice.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0;color:#f9a825"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg><span>' + message + '</span>';
    document.body.appendChild(notice);

    requestAnimationFrame(function() {
      notice.classList.add('is-visible');
    });

    setTimeout(function() {
      notice.classList.remove('is-visible');
      setTimeout(function() { notice.remove(); }, 400);
    }, 7000);
  });
})();


